import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import CheckboxComponent from 'components/Checkbox';
import Label from 'components/Label';

interface CheckboxLabelProps {
  $disabled: boolean;
}

export const Container = styled.section`
  display: flex;
  flex-direction: column;
`;

export const Checkbox = styled(CheckboxComponent)`
  margin: 8px 0;

  & > .checkbox {
    height: 24px;
    width: 24px;
    min-width: 24px;
  }

  &:first-child {
    margin-top: 16px;
  }

  &:last-child {
    margin-bottom: 16px;
  }
`;

export const CheckboxLabel = styled(Label)<CheckboxLabelProps>`
  padding: 0 0 0 16px;
  font-size: 14px;
  color: ${({ $disabled, theme }) => ($disabled ? ColorPalette.HEX.MetallicSilver : theme.filters.color)} !important;

  @media ${({ theme }) => theme.device.desktop} {
    font-size: 12px;
  }
`;

export const CheckboxCount = styled.span`
  margin-left: auto;
  padding-left: 4px;

  @media ${({ theme }) => theme.device.desktop} {
    font-size: 12px;
  }
`;

export const ShowButton = styled.button`
  background: none;
  border: none;

  cursor: pointer;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  font-size: 12px;

  margin: 8px auto;
`;
